import React from "react";
import { formatDate } from "../../../../utils/utils";
import FooterPagination from "../../../../Components/Pagination/FooterPagination";
import { Badge, Card, CardBody } from "reactstrap";
import Loading from "../../../../Components/Loading";
import invocesIcon from "../../../../assets/images/iconsRoles/coinIcon.svg";

import { Link } from "react-router-dom";

const InvoiceStatusBadge = ({ status }) => {
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "failed":
        return "danger";
      case "funded":
        return "success";
      default:
        return "warning";
    }
  };

  return <Badge color={getStatusColor(status)}>{status}</Badge>;
};

const InvoicesStatus = ({ loading, invoices, paginationProps }) => {
  return (
    <>
      <div className="col-12 d-flex flex-row align-items-center">
        <div className="d-flex align-items-center">
          <img
            src={invocesIcon}
            alt="invocesIcon"
            className="me-2 ps-3"
            style={{ width: "42px" }}
          />
          <h2 className="mb-0">Invoices Status</h2>
        </div>
      </div>

      <Card className="mb-0 ">
        <CardBody className="">
          <div className="table-container  position-relative">
            {loading && <Loading />}
            <div className="live-preview">
              <div className="table-responsive ">
                <table className="table table-centered table-nowrap mb-0">
                  <thead className="bg" style={{ background: "var(--thead-bg)" }}>
                    <tr>
                      <th>Employer</th>
                      <th>New status</th>
                      <th>Old Status</th>
                      <th>Amount</th>
                      <th>Date</th>
                      <th>Manage</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoices?.map((invoice) => (
                      <tr key={invoice.id}>
                        <td>{invoice.details.biller_name}</td>
                        <td>
                          {InvoiceStatusBadge({ status: invoice.newStatus })}
                        </td>
                        <td>
                          {InvoiceStatusBadge({ status: invoice.oldStatus })}
                        </td>
                        <td>${invoice.details.authorization_amount}</td>
                        <td>{formatDate(invoice.updatedAt)}</td>
                        <td>
                          <Link
                            to={`/billing/invoiceDetail/${invoice.invoiceId}`}
                            className="btn btn-sm btn-primary"
                          >
                            View
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  {paginationProps.totalItems > 0 && (
                    <tfoot>
                      <FooterPagination {...paginationProps} />
                    </tfoot>
                  )}
                </table>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </>
  );
};

export default InvoicesStatus;
